require('./RARiskButton.scss');

const React = require('react');
const PropTypes = require('prop-types');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { FormattedText } = require('core/i18n').i18n;

class RARiskButton extends React.Component {
    render() {
        const { inverse, modifier, onClick } = this.props;
        return (
            <OKButton
                modifier={modifier}
                inverse={inverse}
                size="small"
                leftIcon="icon-flag-seguimiento ra-risk-button__icon"
                onClick={onClick}
            >
                <FormattedText value="raRiskButton-raRiskButton_text" />
            </OKButton>
        );
    }
}

RARiskButton.propTypes = {
    inverse: PropTypes.bool,
    modifier: PropTypes.oneOf(['secondary', 'ghost']),
    onClick: PropTypes.func.isRequired,
};

RARiskButton.defaultProps = {
    inverse: false,
    modifier: 'secondary',
};

module.exports = RARiskButton;
